import { useState } from "react"
import Link from "next/link"
import classNames from "classnames"
import Block from "@/components/wrappers/block"
import Arrow from "@/common/icons/arrow"
import Download from "@/common/icons/download"
import styles from "./project-single.module.css"

export default function ProjectSingle({ block }) {
  const { project } = block.attrs

  if (!project?.title) {
    return null
  }

  return (
    <Block block={block} width="column" className={styles.wrapper}>
      <h1>{project.title}</h1>
      <Meta project={project} />
      {project.description && (
        <>
          <h2>Beskrivning</h2>
          <p>{project.description}</p>
        </>
      )}
      {project.images && project.images.length === 1 && (
        <Image image={project.images[0]} />
      )}
      {project.images && project.images.length > 1 && (
        <SlideShow images={project.images} />
      )}
    </Block>
  )
}

const Meta = ({ project }) => {
  return (
    <ul className="information">
      {project.meta.map((item, key) => {
        let value, hasValue

        switch (item.type) {
          case "term":
            value = item.value.map((term) => {
              return (
                <Link key={term.slug} href={term.url}>
                  {term.name}
                </Link>
              )
            })
            hasValue = value.length > 0
            break

          case "mixed":
            value = item.value
            hasValue = !!value
            break

          case "files":
            value = item.value.map((document, key) => (
              <a key={"file" + key} href={document.url}>
                <span>{document.file}</span>
                <div className="icon">
                  <Download fill="white" />
                </div>
              </a>
            ))
            hasValue = value.length > 0
            break

          default:
            value = item.value
            hasValue = value.length > 0
            break
        }

        if (!hasValue) {
          return null
        }

        return (
          <li className={item.type} key={"item" + key}>
            <strong>{item.label}</strong>
            <span>{value.length === 0 ? "–" : value}</span>
          </li>
        )
      })}
    </ul>
  )
}

const Image = ({ image }) => {
  if (!image.url) {
    return null
  }

  return (
    <>
      <figure>
        <img src={image.url} alt={image?.alt} />
      </figure>
      {image?.caption && <p className="caption">{image.caption}</p>}
    </>
  )
}

const SlideShow = ({ images }) => {
  const [currentImage, setCurrentImage] = useState(0)

  const hasPrev = currentImage > 0
  const hasNext = currentImage < images.length - 1

  return (
    <div className="slide-show">
      <Image image={images[currentImage]} />
      <nav>
        <button
          aria-label="Föregående"
          className={classNames("prev", { disabled: !hasPrev })}
          onClick={() => hasPrev && setCurrentImage((prev) => prev - 1)}>
          <Arrow />
        </button>
        <ul>
          {images.map((_, key) => (
            <li
              key={"dot-" + key}
              className={classNames({ active: currentImage === key })}
              onClick={() => setCurrentImage(key)}
            />
          ))}
        </ul>
        <button
          aria-label="Nästa"
          className={classNames("next", { disabled: !hasNext })}
          onClick={() => hasNext && setCurrentImage((prev) => prev + 1)}>
          <Arrow />
        </button>
      </nav>
    </div>
  )
}
